import { Route, Routes } from "react-router-dom";

import { AppProviders } from "@/providers";
import { ProtectedRoute, PublicAuthRoute } from "@/components/protected-route";

import { HomePage } from "@/pages/home";
import { LoginPage } from "@/pages/login";
import { SignupPage } from "@/pages/signup";
import { CheckEmailPage } from "@/pages/check-email";
import { VerifyEmailPage } from "@/pages/verify-email";
import { EventsListPage as EventsPage } from "@/pages/events";
import { NewEventPage } from "@/pages/events/new";
import { EventDetailPage } from "@/pages/events/detail";
import { OrdersPage } from "@/pages/orders";
import { OrderDetailPage } from "@/pages/orders/detail";
import { PromotionsPage } from "@/pages/promotions";
import { NewPromotionPage } from "@/pages/promotions/new";
import { PromotionDetailPage } from "@/pages/promotions/detail";
import { SettingsPage } from "@/pages/settings";
import { LegalOverridesPage as LegalSettingsPage } from "@/pages/settings/legal";
import { NewShopPage } from "@/pages/shops/new";
import { ShopDetailPage } from "@/pages/shops/detail";

export function App() {
  return (
    <AppProviders>
      <Routes>
        {/* Auth-redirect-exempt public sayfalar */}
        <Route element={<PublicAuthRoute allowAuthenticated />}>
          <Route path="/check-email" element={<CheckEmailPage />} />
          <Route path="/verify-email" element={<VerifyEmailPage />} />
        </Route>

        {/* Auth sayfaları (login'liyse /'a redirect) */}
        <Route element={<PublicAuthRoute />}>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
        </Route>

        {/* Auth gerektiren sayfalar */}
        <Route element={<ProtectedRoute />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/shops/new" element={<NewShopPage />} />
          <Route path="/shops/:slug" element={<ShopDetailPage />} />
          <Route path="/events" element={<EventsPage />} />
          <Route path="/events/new" element={<NewEventPage />} />
          <Route path="/events/:slug" element={<EventDetailPage />} />
          <Route path="/orders" element={<OrdersPage />} />
          <Route path="/orders/:orderNumber" element={<OrderDetailPage />} />
          <Route path="/promotions" element={<PromotionsPage />} />
          <Route path="/promotions/new" element={<NewPromotionPage />} />
          <Route path="/promotions/:id" element={<PromotionDetailPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/settings/legal" element={<LegalSettingsPage />} />
        </Route>
      </Routes>
    </AppProviders>
  );
}
